import { render, staticRenderFns } from "./SaveAndExit.vue?vue&type=template&id=796a93d7&scoped=true&"
import script from "./SaveAndExit.vue?vue&type=script&lang=js&"
export * from "./SaveAndExit.vue?vue&type=script&lang=js&"
import style0 from "./SaveAndExit.vue?vue&type=style&index=0&id=796a93d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a93d7",
  null
  
)

export default component.exports